module.exports = __webpack_public_path__ + "static/media/pcamkurz.43067d7d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/pcam/images/pcamkurz.mp4
// module id = 517
// module chunks = 0